<template>
  <b-row class="margin-0">
    <b-col cols="12" class="padding-0">
      <Input
        :title="$lang.username"
        :label="$lang.username"
        :placeholder="$lang.username"
        :value="form.username"
        name="username"
        id="username"
        type="text"
        :minLength="lengthNumber5"
        :maxLength="lengthNumber16"
        :vuelidateObj="$v.form.username"
        rowClass="margin-bottom-8"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" class="padding-0 margin-bottom-16 flex-between">
      <PasswordInputWithRandomPassword
        :title="$lang.newPassword"
        :label="$lang.newPassword"
        :placeholder="$lang.newPassword"
        :infoTooltip="$lang.passwordFormatTooltip"
        :value="form.password"
        name="password"
        id="password"
        type="password"
        :minLength="lengthNumber8"
        :maxLength="lengthNumber32"
        :vuelidateObj="$v.form.password"
        :hasLeftIcon="true"
        :isPasswordChecker="true"
        rowClass="width-percent-100"
        autocomplete="new-password"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" class="padding-0">
      <Checkbox
        :label="$lang.sendChangeToUser"
        :value="form.sendSms"
        name="sendSms"
        @input="input"
      />
    </b-col>
    <b-col cols="12" class="padding-0 flex-end">
      <Button
        contentClass="justify-content-center"
        variant="filled-complementary"
        :text="$lang.cancel"
        @click="handleClose"
      />
      <Button
        class="margin-right-8"
        contentClass="justify-content-center"
        variant="filled-primary"
        :text="$lang.submit"
        :loading="loading"
        @click="handleSubmit"
      />
    </b-col>
  </b-row>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import {
  Input,
  PasswordInputWithRandomPassword,
  Checkbox,
  Button,
} from "@/components/re-design/forms";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import {
  checkPersianCharValidation,
  generateError,
  toastAlert,
} from "@/shared/utils";
import { changeUserPassByAdmin } from "@/modules/profile/services/user-services";

export default {
  mixins: [inputMixin],
  components: { Input, PasswordInputWithRandomPassword, Checkbox, Button },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
    currentUsername: {
      type: [String, Number],
      default: null,
    },
  },
  validations() {
    return {
      form: {
        username: {
          required,
          persianCharacters: (val) => !checkPersianCharValidation(val),
          minLength: minLength(this.lengthNumber5),
          maxLength: maxLength(this.lengthNumber16),
        },
        password: {
          required,
          persianCharacters: (val) => !checkPersianCharValidation(val),
          minLength: minLength(this.lengthNumber8),
          maxLength: maxLength(this.lengthNumber32),
        },
      },
    };
  },
  data() {
    return {
      form: {
        username: null,
        password: null,
        sendSms: false,
      },
      loading: false,
    };
  },
  watch: {
    currentUsername: {
      immediate: true,
      handler(value) {
        if (value) {
          this.input("username", value);
        }
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    getUserDetail() {
      this.$emit("getUserDetail");
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const { username, password, sendSms } = this.form;
        const params = {
          code: this.code,
          username,
          password,
          sendSms: Number(sendSms),
        };
        const response = await changeUserPassByAdmin(params);
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.getUserDetail();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
